/**
 * 页面字典数据接口
 */
import request from '@/utils/requestUtil';

const API = {
  ENTERPRISE_LIST_URL: '/tool/searchEnt/listEntName?name=',
  ENTERPRISE_INFO_URL: '/tool/searchEnt/entInfo?name=',
  DISTRICT_LIST_URL: '/tool/dict/listDistrict',
  INDUSTRY_LIST_URL: '/tool/dict/listIndustry?level=2',
  SCALE_INDUSTRY_LIST_URL: '/tool/scale/getScaleIndustry',
  DOMAIN_LIST_URL: '/tool/toolGxDomain/listAll',
}

// 企业查询
export const reqEnterpriseList = (name) => request.get(API.ENTERPRISE_LIST_URL + name);
// 企业相关信息
export const reqEnterpriseInfo = (name) => request.get(API.ENTERPRISE_INFO_URL + name);
// 地区列表
export const reqDistrictList = () => request.get(API.DISTRICT_LIST_URL);
// 行业列表
export const reqIndustryList = () => request.get(API.INDUSTRY_LIST_URL);
// 企业规模测试行业列表
export const reqScaleIndustryList = () => request.get(API.SCALE_INDUSTRY_LIST_URL);
// 技术领域
export const reqDomainList = () => request.get(API.DOMAIN_LIST_URL);